import React, { useEffect, useState } from 'react';

import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import Gallery from '../components/imageAndGraphics/gallery/Gallery';

import { db } from '../config/firebase';

const imageLayout = () => {
    const [ images, setImages ] = useState([]);

    useEffect(() => {
        db.collection('images').orderBy('timestamp', 'desc').onSnapshot(snapshot => {
          setImages(snapshot.docs.map(doc => ({id: doc.id, image: doc.data()})));
        })
      }, []);
    
    return (
        <div>
            <Header />
            <Gallery title="PHOTOS" data={images} />
            <Footer/>
        </div>
    );
};

export default imageLayout;


// WEBPACK FOOTER //
// ./src/pages/imageLayout.js